<div class="wrapper">
  <div class="container">
    <div class="input-group mb-3 custom">
      <div class="input-div-address">
        <input #addressField type="search" class="form-control form-control-sm search-control" placeholder="{{'Search address' | translate}}"
               [(ngModel)]="addQuery" qmDebounce [delay]="100" (onDebounce)="doAddressSearch();"
               [autofocus]="true" [qmAutofocus]="true" (click)="resetAddress()"/>
        <div class="add-results" *ngIf="addQuery">
          <div class="custom-list" *ngFor="let row of addressResults">
            <a (click)="selectAddress(row)">{{row.description}}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="input-group mb-3 custom" style="margin-top: 1em;">
      <div class="input-div-vivo">
        <input #searchField type="search" id="this" class="form-control form-control-sm search-control" placeholder="{{'Search for Asset' | translate}}"
               [(ngModel)]="query" qmDebounce [delay]="100"
               (onDebounce)="doSearch();" [autofocus]="true" [qmAutofocus]="true">
          <div class="search-list" *ngIf="query && vivoResults && vivoResults.length > 0">
            <ul>
              <li *ngFor="let single of vivoResults">
                <a (click)="assignAsset(single)">
                  {{single.name + ', ' + single.holder}}
                </a>
              </li>
            </ul>
          </div>
      </div>
    </div>

    <div class="selected-assets">
      <div class="selections" *ngFor="let single of vivoNotification.parents">
        <div class="asset">
          {{single.name}}
          <a class="remove" (click)="removeAsset(single)">
            <i class="fas fa-times"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="input-group mb-3 custom">
      <textarea class="form-control" placeholder="{{'Description' | translate}}" rows="4" cols="100" [(ngModel)]="vivoNotification.message"></textarea>
    </div>


    <div class="wrapper">
      <div class="lappa" (click)="showAutocomplete = true">
        <div class="autocomplete">
          <input id="typeahead-format" type="text" class="form-control"
                 (focus)="onFocus($event)"
                 [(ngModel)]="model"
                 placeholder="{{'Search for members' | translate}}"
                 [inputFormatter]="formatter"
                 [ngbTypeahead]="search"
                 (selectItem)="typeAheadEvent($event)"
                 [resultTemplate]="rt"
                 [resultFormatter]="formatter"/>
        </div>
        <div class="results">
          <span class="addr" *ngFor="let single of vivoNotification.subscribers; let i = index;">
          {{single.name}}
            <a class="remove" (click)="removeUser($event, single)">
              <i class="fas fa-times"></i>
            </a>
          </span>
        </div>
        <ng-template #rt let-r="result" let-t="term" let-id="holderID">
          <div class="d-flex justify-content-between">
            <ngb-highlight [result]="r.name" [term]="t.name">
              <a (click)="typeAheadEvent(t)"></a>
            </ngb-highlight>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="options">
      <div class="input-group manu">
        <div class="input-group-prepend">
          <label class="input-group-text" for="inputGroupSelect01">{{'Priority' | translate}}</label>
        </div>
        <select class="custom-select" id="inputGroupSelect01" [(ngModel)]="vivoNotification.priority.id" [compareWith]="comparePriorities">
          <option [ngValue]="null">{{'Not set' | translate}}</option>
          <option *ngFor="let single of vivoPrioritys" [ngValue]="single">{{single.name}}</option>
        </select>
      </div>
    </div>

    <div class="buttons">
      <div class="save-button">
        <button type="button" class="btn btn-primary custom-button" [disabled]="!vivoNotification.message" (click)="save()">
          {{'Save' | translate}}
        </button>
      </div>
      <div class="cancel-button">
        <button type="button" class="btn btn-warning cancel-button" (click)="close.emit()">
          {{'Cancel' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
